import { customerModuleAndExternalStakeholderRoles } from '~/authorization'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/auth')) {
    return
  }

  const { canAccessPage, hasAnyAssignedRole, hasExactAssignedRoles } = useAuthorization()

  const canUserAccessPage = canAccessPage(to.path)

  // Redirect external service project stakeholder to the only page they have access to
  if (hasAnyAssignedRole(['externalServiceProjectStakeholder'], false).value && !canUserAccessPage) {
    // If the external stakeholder is also an external contractor, redirect to internal view instead.
    if (hasAnyAssignedRole(['externalServiceProjectContractor'], false).value) {
      return navigateTo('/')
    }

    return navigateTo('/my-hos/service-project/reporting')
  }

  // If user has customerModuleAndExternalStakeholderRoles and no other roles, redirect to the customer module
  const shouldRedirectToCustomerModule = hasExactAssignedRoles(customerModuleAndExternalStakeholderRoles)

  // Redirect customerUsers to the other landing page
  if (shouldRedirectToCustomerModule.value && to.path === '/') {
    return navigateTo('/my-hos')
  }

  if (!canUserAccessPage && !to.path.startsWith('/my-hos') && shouldRedirectToCustomerModule.value) {
    return navigateTo('/my-hos')
  }
})
